import { render, staticRenderFns } from "./toolbar-color-picker.vue?vue&type=template&id=feb9cbfc&"
import script from "./toolbar-color-picker.vue?vue&type=script&lang=js&"
export * from "./toolbar-color-picker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports